import ApplicationSwitcherMain from './ApplicationSwitcherMain';
import ApplicationSwitcherClient from './ApplicationSwitcherClient';
import { OPEN, CREATE, SHOW, UPDATE_MODEL } from './events/ApplicationSwitcherObservable';
import { enableAppSwitcher } from './ApplicationSwitcherStatus';
import { eventBus } from '../internal';
import { beforeTimeoutEvent } from '../eventBus/appEventTypes';
import AppRegistryService from './services/AppRegistryService';
class ApplicationSwitcher {
  constructor(config) {
    this.config = config;
    if (window === top?.window) {
      new ApplicationSwitcherMain(config);
    }
    this.client = new ApplicationSwitcherClient(config);
  }
  broadcastMessage(type, data = {}) {
    this.client.broadcastMessage(type, data);
  }
  getAvailableApps() {
    return this.client.getModel().availableApplications;
  }
  async updateFavorites(directives) {
    await this.config.applicationService.updateFavorites(directives);
    // Update this and other appswitcher's favorites.
    await this.client.updateModel();
    this.client.broadcastMessage(UPDATE_MODEL);
  }
  getPublicTypes() {
    return this.client.getModel().publicTypeSupportingApplications;
  }
  gotoApp(appId, url, isCompliant, options) {
    this.client.gotoApp(appId, url, isCompliant, options);
  }
  logoff() {
    this.client.logoff();
  }
  sendMessageToApp(appId, type, data) {
    this.client.sendMessageToApp(appId, type, data);
  }
  setDirtyMessageEnabled(allowDirtyMessage) {
    this.client.setDirtyMessageEnabled(allowDirtyMessage);
  }
  setLogoffUrl(logoffUrl) {
    this.client.setLogoffUrl(logoffUrl);
  }
  subscribe(type, fn, context) {
    this.client.subscribe(type, fn, context);
  }
  timeout(url) {
    this.client.timeout(url);
  }
  unsubscribe(type, fn, context) {
    this.client.unsubscribe(type, fn, context);
  }
  updateAppName(appId, appName) {
    this.client.updateAppName(appId, appName);
  }
  updateDirtyFlag(appId, dirtyFlag) {
    this.client.updateDirtyFlag(appId, dirtyFlag);
  }
  registerApp(appId, url, appName) {
    this.client.registerApp(appId, url, appName);
  }
  openObject(objectType, objectInfo, preferredAppId) {
    this.client.openObject(objectType, objectInfo, OPEN, preferredAppId);
  }
  createObject(objectType, objectInfo, preferredAppId) {
    this.client.openObject(objectType, objectInfo, CREATE, preferredAppId);
  }
  updateModel() {
    this.client.updateModel();
  }
  setUnsavedChangesLocalizedFn(fn) {
    this.config.getUnsavedChangesLocalizedString = fn;
  }
  getAvailableApp(appId) {
    return this.client.getAvailableApp(appId);
  }
}
export const createApplicationSwitcher = config => {
  const applicationSwitcher = new ApplicationSwitcher(config);
  enableAppSwitcher();

  // fire up show event on event bus.
  applicationSwitcher.subscribe(SHOW, (_, data) => {
    eventBus.publish(SHOW, {
      data
    });
  });
  // TODO fire other app switcher events on the bus. Rob?
  eventBus.subscribe(beforeTimeoutEvent, () => {
    applicationSwitcher.setDirtyMessageEnabled(false);
  });
  return applicationSwitcher;
};
const getLogoffUrl = () => {
  const origin = window.location.origin;
  const pathname = window.location.pathname;
  const secondSlashIndex = pathname.indexOf('/', 1);
  const contextPath = pathname.substring(0, secondSlashIndex);
  const logoutPath = '/logout';
  return origin + contextPath + logoutPath;
};
let applicationSwitcher;
export const getApplicationSwitcher = () => {
  if (!applicationSwitcher) {
    applicationSwitcher = createApplicationSwitcher({
      applicationService: new AppRegistryService(),
      getLogoffUrl,
      getUnsavedChangesLocalizedString: () => {
        return '';
      }
    });
  }
  return applicationSwitcher;
};
export const setApplicationSwitcher = customApplicationSwitcher => {
  applicationSwitcher = customApplicationSwitcher;
};
export default ApplicationSwitcher;
//# sourceMappingURL=ApplicationSwitcher.js.map